<template>
  <div class="home">
    <div id="timemap_banner" class="container mt-3 mb-3">
      <!-- <TimeMap
        ref="timemap"
        style="
          width: 100%;
          height: calc(100vh - 180px);
          margin-top: -16px;
          min-height: 400px;
          max-height: 800px;
        "
        v-model:showFeatures="is_show_amap_features"
      ></TimeMap> -->
      <TimeMap ref="timemap" class="timemap" v-model:showFeatures="is_show_amap_features" :center="map_center"
        :level="map_level" :city="map_city" @mapready="get_city_info"></TimeMap>

      <ul id="map_menu" class="nav flex-column nav-pills">
        <li class="nav-item">
          <a class="btn banner-btn" :class="is_show_amap_features ? 'btn-primary' : 'btn-light'" href="#"
            @click="switch_amap_features"><i class="bi bi-layers map_menu_btn_logo"></i>
            <span>现代地名</span></a>
        </li>
        <li class="nav-item">
          <a class="btn banner-btn btn-light" href="#" @click="timemap.get_geolocation()"><i
              class="bi bi-geo map_menu_btn_logo"></i>
            <span>我的位置</span></a>
        </li>
        <li class="nav-item">
          <a class="btn banner-btn btn-light" href="https://db.timemarking.com"><i
              class="bi bi-database map_menu_btn_logo"></i>
            <span>数据服务</span></a>
        </li>
        <li class="nav-item">
          <router-link :to="{
            name: 'Map',
            params: { region_id: $route.params.region_id },
          }" class="btn banner-btn btn-light">
            <i class="bi bi-cursor map_menu_btn_logo"></i>
            <span>地图服务</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{
            name: 'Page',
            params: { id: 'app', region_id: $route.params.region_id },
          }" class="btn banner-btn btn-light">
            <i class="bi bi-download map_menu_btn_logo"></i>
            <span>智能应用</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{
            name: 'Page',
            params: { id: 'timeline', region_id: $route.params.region_id },
          }" class="btn banner-btn btn-light">
            <i class="bi bi-magic map_menu_btn_logo"></i>
            <span>时空轨迹</span>
          </router-link>
        </li>
      </ul>
    </div>

    <!-- <div id="map" class="heroe">
      <div>
        <h1>时空导航</h1>
        <h2>标语1</h2>
        <h2>标语2</h2>
      </div>
    </div> -->

    <!-- <div id="timeline" class="heroe">
      <div class="container">
        <div>
          <h1>时空轨迹宣传图片</h1>
          <h2>标语1</h2>
          <h2>标语2</h2>
        </div>
      </div>
    </div> -->
    <div class="container">
      <div id="location" class="heroe">
        <div class="container">
          <div class="data_container">
            <h1>地域历史</h1>
            <div v-for="item in locations" v-bind:key="item">
              <figure>
                <blockquote class="blockquote">
                  <h4>
                    <router-link :to="{
                      name: 'Location',
                      params: {
                        id: item.id,
                        region_id: $route.params.region_id,
                      },
                    }" target="_blank">{{ item.name }}</router-link>
                  </h4>
                </blockquote>
              </figure>
              <p class="muted">{{ item.address }}</p>
            </div>
            <div>
              <router-link :to="{
                name: 'Data',
                params: {
                  type: 'location',
                  region_id: $route.params.region_id,
                },
              }" class="btn btn-outline-primary">
                更多
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div id="person" class="heroe">
        <div class="container">
          <div class="data_container">
            <h1>历史人物</h1>
            <div v-for="item in persons" v-bind:key="item">
              <figure>
                <blockquote class="blockquote">
                  <h4>
                    <router-link :to="{
                      name: 'Person',
                      params: {
                        id: item.id,
                        region_id: $route.params.region_id,
                      },
                    }" target="_blank">{{ item.name }}</router-link>
                  </h4>
                </blockquote>
                <figcaption class="blockquote-footer" v-if="item.time">
                  <BCDateRangeView :value="item.time" />
                </figcaption>
              </figure>
              <p class="muted">{{ item.intro }}</p>
            </div>
            <div>
              <router-link :to="{
                name: 'Data',
                params: {
                  type: 'person',
                  region_id: $route.params.region_id,
                },
              }" class="btn btn-outline-primary">
                更多
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div id="history" class="heroe">
        <div class="container">
          <div class="data_container">
            <h1>历史事件</h1>
            <div v-for="item in historirs" v-bind:key="item">
              <figure>
                <blockquote class="blockquote">
                  <h4>
                    <router-link :to="{
                      name: 'History',
                      params: {
                        id: item.id,
                        region_id: $route.params.region_id,
                      },
                    }" target="_blank">{{ item.name }}</router-link>
                  </h4>
                </blockquote>
                <figcaption class="blockquote-footer" v-if="item.time">
                  <BCDateRangeView :value="item.time" />
                </figcaption>
              </figure>
              <p class="muted">{{ item.intro }}</p>
            </div>
            <div>
              <router-link :to="{
                name: 'Data',
                params: {
                  type: 'history',
                  region_id: $route.params.region_id,
                },
              }" class="btn btn-outline-primary">
                更多
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div id="organize" class="heroe">
        <div class="container">
          <div class="data_container">
            <h1>组织变迁</h1>
            <div v-for="item in organizes" v-bind:key="item">
              <figure>
                <blockquote class="blockquote">
                  <h4>
                    <router-link :to="{
                      name: 'Organize',
                      params: {
                        id: item.id,
                        region_id: $route.params.region_id,
                      },
                    }" target="_blank">{{ item.name }}</router-link>
                  </h4>
                </blockquote>
                <figcaption class="blockquote-footer" v-if="item.time">
                  <BCDateRangeView :value="item.time" />
                </figcaption>
              </figure>
              <p class="muted">{{ item.intro }}</p>
            </div>
            <div>
              <router-link :to="{
                name: 'Data',
                params: {
                  type: 'organize',
                  region_id: $route.params.region_id,
                },
              }" class="btn btn-outline-primary">
                更多
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="hmap" class="heroe">
      <div class="container">
        <div>
          <a href="https://h-map.timemarking.com" target="_blank">
            <img src="@/assets/h-map2.png" alt="历史地图" />
          </a>
        </div>
      </div>
    </div>

    <div class="container">
      <div id="data" class="heroe">
        <div class="container">
          <div>
            <a :href="db_link">
              <h1>数据服务 宣传图片</h1>
              <h2>标语1</h2>
              <h2>标语2</h2>
            </a>
          </div>
        </div>
      </div>

      <div id="download" class="heroe">
        <div class="container">
          <div>
            <router-link :to="{
              name: 'Page',
              params: { id: 'app', region_id: $route.params.region_id },
            }">
              <h1>智能应用 宣传图片</h1>
              <h2>标语1</h2>
              <h2>标语2</h2>
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- 选择城市的model -->
  <div class="modal fade" id="city_select_model" tabindex="-1" aria-labelledby="city_select_model" aria-hidden="true"
    style="z-index: 10000;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">请选择您的城市</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="city_select_item fs-5 fw-bold" v-if="city_select_context.parent != ''">
            <router-link :to="{
              name: 'Home',
              params: { region_id: city_select_context.parent },
            }" @click="show_city_select_model_button.click()">{{ city_select_context.parent_name }}</router-link>
          </div>
          <div class="city_select_item fs-5" v-for="item in city_select_context.list" v-bind:key="item.code">
            <router-link v-if="city_select_context.parent != '' || is_big_city(item.code)" :to="{
              name: 'Home',
              params: { region_id: item.code },
            }" @click="show_city_select_model_button.click()">{{ item.name }}</router-link>
            <a v-else href="javascript:void(0)" @click="refresh_city_select_context(item.code)">{{ item.name }}</a>
          </div>
          <button type="button" ref="show_city_select_model_button" class="btn btn-primary city_select_panel_control"
            data-bs-toggle="modal" data-bs-target="#city_select_model">
          </button>
        </div>
        <div v-if="city_info" class="modal-footer">
          <p class="fs-5">
            您所在的城市是
            <router-link :to="{
              name: 'Home',
              params: { region_id: city_info.code },
            }" @click="show_city_select_model_button.click()">{{ city_info.city }}</router-link>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { ref } from "@vue/reactivity";

import BCDateRangeView from "../components/BCDateRangeView.vue";
import TimeMap from "../components/TimeMap.vue";

import { get_region_id_from_url } from "@/composables/Utils.js";
import { nextTick, watch } from "@vue/runtime-core";
import router from "@/router";

export default {
  components: {
    BCDateRangeView,
    TimeMap,
  },
  setup() {
    const timemap = ref();
    const is_show_amap_features = ref(false);
    let region_id = get_region_id_from_url();

    const switch_amap_features = function () {
      is_show_amap_features.value = !is_show_amap_features.value;
    };

    const locations = ref([]);
    const persons = ref([]);
    const historirs = ref([]);
    const organizes = ref([]);

    function load_list_data() {
      region_id = get_region_id_from_url();
      axios.get("/api/location/" + (region_id != "" ? `?region=${region_id}` : "")).then((response) => {
        locations.value = response.data.results.slice(0, 5);
      });

      axios.get("/api/person/").then((response) => {
        persons.value = response.data.results.slice(0, 3);
      });

      axios.get("/api/history/").then((response) => {
        historirs.value = response.data.results.slice(0, 3);
      });

      axios.get("/api/organize/").then((response) => {
        organizes.value = response.data.results.slice(0, 3);
      });
    }

    const map_center = ref([104.230243, 35.063695]);
    const map_level = ref(4);
    const map_city = ref(region_id);
    const db_link = ref("https://db.timemarking.com");

    function set_map_center_and_level(region_id) {
      if (region_id === undefined) {
        region_id = get_region_id_from_url();
      }

      if (map_city.value == region_id && map_city.value != "") {
        map_city.value = region_id +
          (region_id.length < 6 ? "00" : "000");
      }
      else {
        map_city.value = region_id;
      }
      if (region_id.startsWith("2101")) {
        // 莫名其妙设置两遍才能解决一个BUG
        map_center.value = [123.434426, 41.80452];
        map_level.value = 14;
        nextTick(() => {
          timemap.value.set_center([123.434426, 41.80452]);
          timemap.value.set_level(14);
        });
      } else if (region_id == "") {
        nextTick(() => {
          timemap.value.set_center([104.230243, 35.063695]);
          timemap.value.set_level(4);
        });
      }

      if (region_id == "21") {
        db_link.value = "https://ln.db.timemarking.com";
      } else if (region_id == "2101") {
        db_link.value = "https://sy.db.timemarking.com";
      } else {
        db_link.value = "https://db.timemarking.com";
      }

      load_list_data();
    }

    set_map_center_and_level();

    watch(router.currentRoute, (to, from) => {
      if (from.name === undefined) {
        return;
      }
      if (
        from.name == to.name &&
        from.params.region_id == to.params.region_id
      ) {
        return;
      }
      if (to.name == "Home") {
        set_map_center_and_level(to.params.region_id);
      }
    });


    // 首次进入中国首页时，显示选择城市面板
    const city_select_context = ref({
      is_show: false,
      parent: "",
      parent_name: "",
      list: [],
    });

    const show_city_select_model_button = ref();
    let is_first_show_city_select_model = false;

    const refresh_city_select_context = function (region_id) {
      city_select_context.value.parent = region_id;
      // let parent_name_query = null;
      if (region_id.length == 2) {
        axios.get("/api/region/" + region_id + "/").then((response) => {
          city_select_context.value.parent_name = response.data.name;
        });
      }
      city_select_context.value.list = [];
      axios.get("/api/region/?code=" + region_id).then((response) => {
        city_select_context.value.list = response.data;
        // if (parent_name_query != null) {
        //   parent_name_query.join();
        // }
        nextTick(() => {
          city_select_context.value.is_show =
            (map_city.value == "" || (map_city.value.length <= 4 && !is_big_city(map_city.value.substring(0, 2))));
          if (city_select_context.value.is_show && !is_first_show_city_select_model) {
            is_first_show_city_select_model = true;
            show_city_select_model_button.value.click();
          }
        });
      });
    };

    refresh_city_select_context(region_id);

    const is_big_city = function (code) {
      return ["11", "12", "31", "50", "81", "82"].indexOf(code) >= 0;
    };

    // 根据IP地址定位用户所在城市
    const city_info = ref(null);
    const get_city_info = function () {
      let info = {
        code: timemap.value.get_citycode()
      }
      if (is_big_city(info.code)) {
        info.code = info.code.substring(0, 2);
      }
      else {
        info.code = info.code.substring(0, 4);
      }
      axios.get(`/api/region/${info.code}/`).then((response) => {
        info.city = response.data.name;
        city_info.value = info;
      });
    }


    return {
      timemap,
      is_show_amap_features,
      switch_amap_features,
      locations,
      persons,
      historirs,
      organizes,

      map_center,
      map_level,
      map_city,

      db_link,

      city_select_context,
      show_city_select_model_button,
      refresh_city_select_context,
      is_big_city,
      get_city_info,
      city_info,
    };
  },
};
</script>
<style scoped>
#timemap_banner {
  /* position: relative; */
  display: flex;
  flex-direction: row-reverse;
}

.banner-btn {
  border: grey 1px solid;
}

.timemap {
  width: 100%;
  height: 600px;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.2);
}

#map_menu {
  /* position: absolute;
  top: 20px;
  left: calc(50% - 100px); */
  /* background-color: white;
  border-radius: 10px;
  border-color: gray;
  border-width: 1px;
  border-style: solid; */
  width: 115px;
  /* list-style: none;
  padding: 0; */
  margin-right: 15px;
}

#map_menu .nav-item {
  width: 100%;
  height: 100px;
}

#map_menu .nav-item .btn {
  width: 100%;
  height: 90px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.map_menu_btn_logo {
  font-size: 30px;
}

@media (max-width: 992px) {
  #timemap_banner {
    /* position: relative; */
    flex-direction: column;
  }

  #map_menu {
    flex-direction: row !important;
    justify-content: center;
    width: 100%;
  }

  #map_menu .nav-item {
    width: 130px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 20px;
    height: 90px;
  }
}

.heroe {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* list-style: none; */
  padding: 0;
  min-height: 600px;
  width: 100%;
  text-align: center;
  background-repeat: no-repeat;
  padding-bottom: 10px;
  padding-top: 10px;
}

.heroe .container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-repeat: no-repeat;
  min-height: 600px;
}

#map {
  background-image: url("../assets/banner_map.jpg");
  background-position: center;
}

#timeline {
  background-color: #99ccff;
}

#timeline .container {
  background-image: url("../assets/banner_timeline_3.jpg");
  background-position: right;
  justify-content: left;
}

#timeline .container div {
  width: calc(100% - 526px);
}

@media (max-width: 992px) {
  #timeline .container {
    background-position: center;
  }

  #timeline .container div {
    width: 100%;
  }
}

#data {
  background-color: #d1eef4;
}

#data .container {
  background-image: url("../assets/banner_data.jpg");
  background-position: center;
}

#download .container {
  background-image: url("../assets/banner_download.jpg");
  background-position: left;
  justify-content: right;
}

#download .container div {
  width: calc(100% - 418px);
}

@media (max-width: 992px) {
  #download .container {
    background-position: center;
  }

  #download .container div {
    width: 100%;
  }
}

.data_container {
  width: calc(100% - 400px);
  position: relative;
  /* background-color: rgba(255, 255, 255, 0.3); */
}

/* .data_container a {
  color: white;
} */

#location {
  background-color: #99ccff;
}

#location .container {
  background-image: url("../assets/banner_location_3.jpg");
  background-position: right;
  justify-content: left;
  text-align: left;
}

#person {
  background-color: #663333;
}

#person .container {
  background-image: url("../assets/banner_person_2.jpg");
  background-position: left;
  justify-content: right;
  text-align: right;
  color: white;
}

#history {
  background-color: #99ccff;
}

#history .container {
  background-image: url("../assets/banner_history_2.jpg");
  background-position: right;
  justify-content: left;
  text-align: left;
}

#organize {
  background-color: #6699cc;
}

#organize .container {
  background-image: url("../assets/banner_organize_2.jpg");
  background-position: left;
  justify-content: right;
  text-align: right;
  color: white;
}

@media (max-width: 992px) {
  /* #location .container {
    background-position: center;
    justify-content: center;
  }

  #person .container {
    background-position: center;
    justify-content: center;
  }

  #history .container {
    background-position: center;
    justify-content: center;
  }

  #organize .container {
    background-position: center;
    justify-content: center;
  } */
}

@media (max-width: 768px) {
  .heroe {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .data_container {
    width: auto;
    min-height: 600px;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    color: black;
  }

  /* .data_container_bg {
    position: absolute;
    top: -10px;
    left: -10px;
    width: calc(100% + 20px);
    height: calc(100% + 20px);
    background-color: rgba(255, 255, 255, 1);
    filter: blur(3px);
    z-index: 1;
  } */
}

@media (max-width: 576px) {}

.city_select_item {
  display: inline-block;
  margin: 3px;
  margin-left: 8px;
  margin-right: 8px;
}

.city_select_panel_control {
  display: none;
}

#hmap img {
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>